import { getDefaultOTELInstrumentations, TracingInstrumentation } from '@grafana/faro-web-tracing';
import { getWebInstrumentations, initializeFaro, InternalLoggerLevel } from '@grafana/faro-web-sdk';
import { ReplayInstrumentation } from '@grafana/faro-instrumentation-replay';

import { diag, DiagConsoleLogger, DiagLogLevel } from '@opentelemetry/api';

import { BLOCK_SELECTOR, MASK_INPUT_OPTIONS, MASK_TEXT_SELECTOR } from './replayPrivacy';

const {
  NEXT_PUBLIC_FARO_APP_NAME = '',
  NEXT_GRAFANA_FARO_ENDPOINT = '',
} = typeof window !== 'undefined' ? window.ENV : {};

const Faro = async (collectorString: string) => {
  const url = NEXT_GRAFANA_FARO_ENDPOINT || collectorString;

  // Synthetic Monitoring looks the session up by the k6 meta, so keep it for probe runs only. Stripping the rest stops the background load generator tagging every session as k6.
  const k6TestRunId = (window as unknown as { k6?: { testRunId?: string } }).k6?.testRunId;
  const isSyntheticMonitoringRun = typeof k6TestRunId === 'string' && k6TestRunId.startsWith('sm:');

  if (url) {
    initializeFaro({
      beforeSend: item => {
        if (!isSyntheticMonitoringRun) {
          delete item.meta.k6;
        }

        return item;
      },
      url: NEXT_GRAFANA_FARO_ENDPOINT || collectorString,

      app: {
        name: NEXT_PUBLIC_FARO_APP_NAME,
        version: '1.0.0',
        environment: 'production',
      },
      trackGeolocation: true,

      instrumentations: [
        ...getWebInstrumentations(),

        new ReplayInstrumentation({
          samplingRate: 1.0, // Sample recordings at 100%
          maskAllInputs: false,
          maskInputOptions: MASK_INPUT_OPTIONS,
          maskTextSelector: MASK_TEXT_SELECTOR,
          blockSelector: BLOCK_SELECTOR,
        }),

        new TracingInstrumentation({
          instrumentations: [
            ...getDefaultOTELInstrumentations({
              ignoreUrls: [NEXT_GRAFANA_FARO_ENDPOINT],
            }),
          ],
        }),
      ],
      ignoreErrors: [/Minified React error/i],
    });
  }
};

export default Faro;
